/**
 @ngdoc service
 @name mapScreeningmanagerTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapScreeningmanagerTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            tileFactory.addFieldToColumn1(tileFactory.field.newField('id'));
            tileFactory.addFieldToColumn1(tileFactory.field.newInactiveFieldAjax('mobile', 'unsubscribedFromCalls', 'unsubscribedFromCalls',null,'logPhoneCall'));
            tileFactory.addFieldToColumn1(tileFactory.field.newRankedInactiveFieldAjax(
                'telephone',
                [['ctpsBarring', 'ctpsBarring'], ['unsubscribedFromCalls', 'unsubscribedFromCalls']],null,'logPhoneCallTelephone'
            ));

            // tileFactory.addFieldToColumn1(tileFactory.field.newField('email'));
            tileFactory.addFieldToFullWidthRow(tileFactory.field.newWarningField('email', ['invalidEmailWarning', 'spamEmailWarning']));
            tileFactory.addFieldToColumn2(tileFactory.field.newMultipleAddressField('town'));
            tileFactory.addFieldToColumn2(tileFactory.field.newMultipleFieldWithLink('businessName', 'businessURI'));
            tileFactory.addFieldToColumn3(tileFactory.field.newMultipleField('jobTitle'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('department'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('lastContact', 'dateTime'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('title'));

            // Adding status to tile data - only Left status is applicable to screening manager
            // 5086: "Left"
            if(rawTileData.managerStatus && rawTileData.managerStatus.id == tileFactory.LOOKUP_VALUE.MANAGER_STATUS_LEFT){
              tileFactory.addStatus(tileFactory.status.newStatusWithInfoAndStyling('managerStatus', 'statusHelpText', [],[tileFactory.LOOKUP_VALUE.MANAGER_STATUS_LEFT], []));
            }

            if(rawTileData.emailPermission==true) {
                tileFactory.addStatus(tileFactory.status.newLabelStatus('invalidEmailStatus', 'invalidEmailWarning'));
                tileFactory.addStatus(tileFactory.status.newLabelStatus('invalidSpamStatus', 'spamEmailWarning'));
            }

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapScreeningmanagerTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapScreeningmanagerTileService', mapScreeningmanagerTileService);
}());
